import React, {useContext, useEffect, useState} from 'react';
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import {Button, Chip, DialogContent, Grid, InputAdornment, Paper} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import {de, getSetting, getCountryIso2, isPromoter, withPromoterRole, resolveRolePayload} from "../../Helper/Helper";
import Slide from "@material-ui/core/Slide";
import {fade, makeStyles, useTheme} from "@material-ui/core/styles";
import JString from "@easytech-international-sdn-bhd/jstring";
import API_Service, {axiosDefaultConfig, axiosPutConfig, axiosURIencode} from "../../Services/API_Service";
import AppContext from "../../Services/AppContext";
import {
    empty,
    req_cust_list,
    req_regions,
    req_resign_user,
    req_copy_user,
    req_role,
    req_salesman,
    req_update_user,
    req_update_user_outlet,
    req_user_details,
    reset,
    req_settings_branches,
    req_module_setting,
    req_working_shift_list,
    req_cust_area,
    ADMIN_POSITION_PROMOTER
} from "../../Helper/Constants";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import EditIcon from "@material-ui/icons/Edit";
import TextField from "@material-ui/core/TextField";
import {useSnackbar} from "notistack";
import CircularProgress from "@material-ui/core/CircularProgress";
import {grey} from "@material-ui/core/colors";
import MuiPhoneNumber from "material-ui-phone-number";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import InfoIcon from "@material-ui/icons/Info";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import AttachmentIcon from "@material-ui/icons/Attachment";
import MUIDataTable from "mui-datatables";
import moment from "moment/moment";
import DoneIcon from "@material-ui/icons/Done";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import VirtualListCB from "../VirtualListCB";
import VirtualListCA from "../VirtualListCA";
import AttachmentTab from "./AttachmentTab";
import SendIcon from "@material-ui/icons/Send";
import DeleteIcon from "@material-ui/icons/Delete";
import FileCopyIcon from '@material-ui/icons/FileCopy';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PersonIcon from '@material-ui/icons/Person';
import PublicIcon from '@material-ui/icons/Public';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
// import EmailIcon from '@material-ui/icons/Email'; // identity header contact rows moved to Personal
// import PhoneIcon from '@material-ui/icons/Phone';
import Skeleton from '@material-ui/lab/Skeleton';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {
    req_manage_users_profile,
    MY_BANKS,
    REST_DAYS,
    REST_REPEAT_OPTIONS
} from "../../Helper/Constants";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

/* work_start_time/work_end_time moved to Working Shift — manual time options no longer used
const TIME_OPTIONS = (function () {
    var arr = [];
    for (var h = 0; h < 24; h++) {
        var hh = h < 10 ? '0' + h : '' + h;
        arr.push(hh + ':00');
    }
    return arr;
})();
*/

const normalizeTime = (val) => {
    if (!val) return '';
    var s = String(val);
    if (s.length >= 5) return s.substring(0, 5);
    return s;
};

const parseRestDays = (val) => {
    if (!val) return [];
    if (Array.isArray(val)) return val.map((v) => parseInt(v, 10)).filter((v) => !isNaN(v));
    return String(val).split(',').map((v) => parseInt(v, 10)).filter((v) => !isNaN(v));
};

const formatShiftLabel = (s) => {
    if (!s) return '';
    var st = normalizeTime(s.start_time);
    var et = normalizeTime(s.end_time);
    var range = (st || et) ? ' (' + st + ' - ' + et + ')' : '';
    return (s.shift_name || '') + range;
};

const useStyles = makeStyles((theme) => ({
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    appBar: {
        position: 'relative',
        paddingRight: '0!important'
    },
    root: {
        flexGrow: 1
    },
    grid: {
        marginTop: 10,
        paddingLeft: 20,
        paddingRight: 20
    },
    // horizontal negative margin made DialogContent 40px wider than the dialog paper -> horizontal scrollbar;
    // same 4px side inset via padding instead (vertical margins unchanged)
    dlgContent: {marginTop: -10, marginBottom: -20, paddingLeft: 4, paddingRight: 4},
    paper: {
        padding: 10,
        marginBottom: 10
    },
    viewInRowSpace: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between'
    },
    input: {
        marginTop: 10,
        width: '48%',
        height: 50
    },
    remark: {
        marginTop: 10,
        width: '100%',
        height: 50
    },
    text: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightMedium,
    },
    bottomNav: {
        flex: 'auto'
    },
    infoContainer: {
        padding: theme.spacing(3),
        paddingBottom: theme.spacing(6),
    },
    identityHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2.5),
        padding: theme.spacing(2.5, 3),
        marginBottom: theme.spacing(3),
        borderBottom: `1px solid ${theme.palette.type === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)'}`,
        flexWrap: 'wrap',
    },
    avatarCircle: {
        width: 64,
        height: 64,
        borderRadius: '50%',
        background: '#FEF200',
        color: '#1a1a1a',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 24,
        fontWeight: 700,
        letterSpacing: '0.02em',
        flexShrink: 0,
        boxShadow: '0 2px 12px rgba(254,242,0,0.35)',
    },
    identityMain: {
        flex: 1,
        minWidth: 220,
    },
    identityName: {
        fontSize: 22,
        fontWeight: 700,
        lineHeight: 1.2,
        color: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.95)' : 'rgba(0,0,0,0.88)',
        marginBottom: 4,
    },
    identityMeta: {
        fontSize: 12,
        color: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.55)' : 'rgba(0,0,0,0.55)',
        letterSpacing: '0.02em',
        marginBottom: 8,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 4,
    },
    identityMetaSep: {
        margin: '0 4px',
        color: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.25)' : 'rgba(0,0,0,0.25)',
    },
    identityMetaLabel: {
        fontSize: 10,
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        color: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.42)',
        marginRight: 4,
    },
    identityMetaValue: {
        fontSize: 12,
        fontWeight: 600,
        color: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.82)' : 'rgba(0,0,0,0.78)',
    },
    identityBadges: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        flexWrap: 'wrap',
    },
    roleBadge: {
        backgroundColor: '#FEF200',
        color: '#1a1a1a',
        fontWeight: 600,
        fontSize: 12,
        height: 24,
    },
    roleBadgeManager: {
        backgroundColor: 'orangered',
        color: '#fff',
        fontWeight: 600,
        fontSize: 12,
        height: 24,
    },
    roleBadgeAgent: {
        backgroundColor: 'yellowgreen',
        color: '#fff',
        fontWeight: 600,
        fontSize: 12,
        height: 24,
    },
    roleBadgePromoter: {
        // backgroundColor: '#9C27B0',
        backgroundColor: '#FF9800',
        color: '#fff',
        fontWeight: 600,
        fontSize: 12,
        height: 24,
    },
    promoterChip: {
        // backgroundColor: '#9C27B0',
        backgroundColor: '#FF9800',
        color: '#fff',
        marginLeft: 8
    },
    statusDotWrap: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        fontSize: 12,
        fontWeight: 600,
        color: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.65)',
    },
    statusDotActive: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: '#22c55e',
        boxShadow: '0 0 0 3px rgba(34,197,94,0.18)',
    },
    statusDotInactive: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: '#ef4444',
        boxShadow: '0 0 0 3px rgba(239,68,68,0.18)',
    },
    identityContact: {
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        marginLeft: 'auto',
        minWidth: 200,
    },
    identityContactRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        fontSize: 13,
        color: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.75)' : 'rgba(0,0,0,0.7)',
    },
    identityContactIcon: {
        width: 28,
        height: 28,
        borderRadius: 8,
        background: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.05)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.55)',
        '& svg': { fontSize: 16 },
    },
    sectionCard: {
        padding: theme.spacing(2.5, 3),
        borderRadius: 16,
        background: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.02)' : '#ffffff',
        border: `1px solid ${theme.palette.type === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.05)'}`,
        boxShadow: theme.palette.type === 'dark'
            ? '0 1px 3px rgba(0,0,0,0.25)'
            : '0 1px 3px rgba(0,0,0,0.04)',
        height: '100%',
        boxSizing: 'border-box',
    },
    sectionHeader: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
        paddingBottom: theme.spacing(1.25),
        borderBottom: `2px solid ${theme.palette.type === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)'}`,
    },
    sectionAccent: {
        width: 4,
        height: 20,
        backgroundColor: '#FEF200',
        borderRadius: 2,
        marginRight: theme.spacing(1.25),
        flexShrink: 0,
    },
    sectionIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: theme.spacing(1),
        color: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.55)' : 'rgba(0,0,0,0.5)',
        '& svg': { fontSize: 18 },
    },
    sectionTitle: {
        fontSize: 13,
        fontWeight: 700,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        color: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.82)' : 'rgba(0,0,0,0.72)',
    },
    infoFieldWrapper: {
        borderRadius: 10,
        padding: theme.spacing(1.25, 1.75),
        background: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.035)' : 'rgba(0,0,0,0.022)',
        border: `1px solid ${theme.palette.type === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.05)'}`,
        marginTop: theme.spacing(1),
    },
    infoLabel: {
        fontSize: 10,
        fontWeight: 600,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        color: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.42)' : 'rgba(0,0,0,0.42)',
        marginBottom: 3,
    },
    infoValue: {
        fontSize: 14,
        fontWeight: 500,
        whiteSpace: 'pre-line',
        wordBreak: 'break-word',
        lineHeight: 1.5,
        color: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.88)' : 'rgba(0,0,0,0.82)',
    },
    emptyValue: {
        fontSize: 14,
        fontStyle: 'italic',
        color: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.32)' : 'rgba(0,0,0,0.32)',
    },
    restDayChip: {
        marginRight: 4,
        marginTop: 4,
        fontSize: 11,
        height: 22,
    },
    restDayChipActive: {
        marginRight: 4,
        marginTop: 4,
        fontSize: 11,
        height: 22,
        backgroundColor: '#FEF200',
        color: '#1a1a1a',
        fontWeight: 600,
    },
    groupChip: {
        marginRight: 4,
        marginTop: 4,
        fontSize: 11,
        height: 22,
    },
    repeatNote: {
        fontSize: 11,
        color: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
        marginTop: 6,
    },
    restStartSpacing: {
        marginTop: 8,
    },
}));

const useSearchStyle = makeStyles((theme) => ({
    margin: {
        marginTop: theme.spacing(1),
        marginLeft: 0,
        paddingLeft: 0
    },
    root: {
        flexGrow: 1,
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.black, 0.10),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.black, 0.15),
        },
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: 'auto',
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '35ch',
            '&:focus': {
                width: '60ch',
            },
        },
    },
}));

const labels = {
    // login_id: "Login ID",
    login: "Login",
    staff_code: "Staff Code",
    name: "Name",
    contact_no: "Contact No.",
    email: "Email",
    password: "Password",
    remark: "Remark",
    // company: "Branch",
};

const itemDataCell = [
    {
        name: "cust_code",
        label: "Code",
        options: {
            display: true
        }
    },
    {
        name: "cust_company_name",
        label: "Name",
        options: {
            display: true
        }
    },
    // {
    //     name: "company",
    //     label: "Branch",
    //     options: {
    //         display: true,
    //         customBodyRender: (value) => {
    //             if (value) {
    //                 const branch = JSON.parse(value);
    //                 return branch.map((b)=><Chip size="small" label={b.toUpperCase()}/>);
    //             }
    //             return '';
    //         }
    //     }
    // },
    {
        name: "outlet_assigned_date",
        label: "Created Date",
        options: {
            display: true,
            filter: false,
            customBodyRender: (value) => {
                return (
                    moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY')
                )
            }
        }
    },
    {
        name: "outlet_updated_at",
        label: "Last Updated",
        options: {
            display: true,
            filter: false,
            customBodyRender: (value) => {
                return (
                    moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm')
                )
            }
        }
    },
    {
        name: "customer_status",
        label: "Status",
        options: {
            display: true,
            customBodyRender: (value) => {
                switch (value) {
                    case "1" :
                        return (<Chip size="small" icon={<DoneIcon/>} label="Active"/>);
                        break;
                    case "0" :
                        return (<Chip size="small" icon={<CloseIcon/>} label="Inactive"/>);
                        break;
                    default :
                        return (null);
                        break;
                }
            }
        }
    }
];

export default function UserSettingsDetails({open, setClose, language, selectedUserDetails, usersList}) {
    const classes = useStyles();
    const searchClass = useSearchStyle();
    const [axiosConfig, setAxiosConfig] = useState({});
    const [axiosPut, setAxiosPut] = useState({})
    const [gState] = useContext(AppContext);
    const [userDetails, setUserDetails] = useState({});
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [actionDialog, setActionDialog] = useState(false);
    const [fullSPList, setFullSPList] = useState([]);
    const [spList, setSpList] = useState([]);
    const radioGroupRef = React.useRef(null);
    const [actionTo, setActionTo] = useState(null);
    const [action, setAction] = useState(null);
    const [editorDialog, setEditorDialog] = useState(false);
    const [loginIDValue, setLoginIDFV] = useState(empty);
    const [loginValue, setLoginFV] = useState(empty);
    const [nameValue, setNameFV] = useState(empty);
    const [staffCodeValue, setStaffCodeFV] = useState(empty);
    const [passwordValue, setPasswordFV] = useState(empty);
    const [showPassword, setShowPassword] = useState(false);
    const [contactNoValue, setContactNoFV] = useState(empty);
    const [emailValue, setEmailFV] = useState(empty);
    const [remarkValue, setRemarkFV] = useState(empty);
    const [edited, setEdited] = useState(false);
    const {enqueueSnackbar, closeSnackbar} = useSnackbar();
    const snack = (msg, type = 'success') => {
        enqueueSnackbar(msg, {
            variant: type,
            preventDuplicate: true,
            autoHideDuration: type === 'success' ? 2000 : 3000
        });
    }
    const [loading, setLoading] = useState(false);
    const [searchArr, setSearchArr] = useState([]);
    const [regionList, setRegionList] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [branchesList, setBranchesList] = useState([]);
    const [viewRegions, setViewRegions] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState(empty);
    const [selectedRole, setSelectedRole] = useState(empty);
    const [selectedBranch, setSelectedBranch] = useState(empty);
    const [selectedLeader, setSelectedLeader] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [outletList, setOutletList] = useState([]);
    const [newOutletOpen, setNewOutletOpen] = useState(false);
    const [fullCustomerList, setFullCustomerList] = useState([]);
    const [selectedOTR, setSelectedOTR] = useState([]);
    const [activeCustAreaList, setActiveCustAreaList] = useState([]);

    const [icNoValue, setIcNoFV] = useState(empty);
    const [addressValue, setAddressFV] = useState(empty);
    // const [phoneNumberValue, setPhoneNumberFV] = useState(empty); // merged into contact_no (single phone column)
    // const [workStartTimeValue, setWorkStartTimeFV] = useState(empty); // moved to Working Shift (shift_id)
    // const [workEndTimeValue, setWorkEndTimeFV] = useState(empty);
    const [shiftIdValue, setShiftIdFV] = useState(empty);
    const [countryIso2, setCountryIso2] = useState('my');
    const [workingShiftEnabled, setWorkingShiftEnabled] = useState(false);
    const [shiftList, setShiftList] = useState([]);
    const [restDaysValue, setRestDaysFV] = useState([]);
    const [restRepeatWeeksValue, setRestRepeatWeeksFV] = useState(empty);
    const [restStartDateValue, setRestStartDateFV] = useState(empty);
    const [bankNameValue, setBankNameFV] = useState(empty);
    const [bankAccountNoValue, setBankAccountNoFV] = useState(empty);
    const [bankAccountNameValue, setBankAccountNameFV] = useState(empty);

    useEffect(() => {
        if (JString(gState.client).isValid()) {
            var axiosGetConfig = axiosDefaultConfig(gState.client);
            var axiosPut = axiosPutConfig(gState.client);
            setAxiosConfig(axiosGetConfig);
            setAxiosPut(axiosPut);
            getRegions(axiosGetConfig);
            getRoles(axiosGetConfig);
            getBranches(axiosGetConfig);
            loadConfig(gState.client);
            loadCustAreaList(axiosGetConfig);
        }
    }, [gState?.client]);

    useEffect(() => {
        if(selectedUserDetails.login_id){
            loadUserDetails(selectedUserDetails.login_id);
            API_Service.get(req_salesman, axiosConfig).then(({data}) => {
                if (data) {
                    var {result, extraData: api_Sp} = data;
                    result = JString(result).toNumber();
                    if (result === 1) {
                        var _data = [];
                        for (let idx = 0; idx < api_Sp.length; idx++) {
                            const {name, login_id} = api_Sp[idx];
                            if (login_id != selectedUserDetails.login_id) {
                                if (!gState.company) {
                                    _data.push({name: name, value: login_id});
                                } else {
                                    if ('company' in api_Sp[idx]) {
                                        const company = JSON.parse(gState.company);
                                        if (company.includes(api_Sp[idx].company)) {
                                            _data.push({name: name, value: login_id});
                                        }
                                    }
                                }
                            }
                        }
                        // setSpList(spList => (_data));
                        setFullSPList(fullSPList => (api_Sp));
                    }
                }
            });

            if (usersList.length > 0) {
                var _data = [];
                for (let idx = 0; idx < usersList.length; idx++) {
                    const {role_id, name, login_id, position} = usersList[idx];
                    // if (role_id === '1') {
                        _data.push({name: name, value: login_id, position: position});
                    // }
                }
                setSpList(spList => (_data));
            }
        }

    }, [open, selectedUserDetails]);

    useEffect(() => {
        // de("betty-effect", userDetails);
        if(userDetails.regions_id && regionList.length > 0){
            var selected = userDetails.regions_id.map((x)=>{
                var arr = regionList.filter((y)=>{
                    if(x == y.id){
                        return y;
                    }
                });
                return arr[0];
            });
            setViewRegions(selected);
        }

    }, [userDetails, regionList]);

    useEffect(() => {
        if(newOutletOpen){
            loadCustomerList();
        }
    }, [newOutletOpen]);

    const getRegions = (config = axiosConfig) => {
        API_Service.get(req_regions, config).then(({data}) => {
            const {result, extraData} = data;
            if (result) {
                extraData.push({id: reset, name: "-"});
                setRegionList(regionList => (extraData));
            }
        }).catch(de);
    }

    const getRoles = (config = axiosConfig) => {
        API_Service.get(req_role, config).then(({data}) => {
            const {result, extraData} = data;
            if (result) {
                const _roles = withPromoterRole(extraData, language.promoter);
                _roles.push({role_id: reset, name: "-"});
                setRoleList(roleList => (_roles));
            }
        }).catch(de);
    }

    const getBranches = (config = axiosConfig) => {
        API_Service.get(req_settings_branches, config).then(({data}) => {
            const {result, extraData} = data;
            if (result) {
                // extraData.push({role_id: reset, name: "-"});
                setBranchesList(branchesList => (extraData));
            }
        }).catch(de);
    }

    const onClose = () => {
        setClose();
        setCurrentPage(0);
    }

    const loadUserDetails = (login_id ,config = axiosConfig) => {
        API_Service.get(`${req_user_details}?login_id=${login_id}`, config).then(({data}) => {
            const {result, extraData} = data;
            if(result){
                if(extraData.outlet){
                    setOutletList(extraData.outlet);
                }
                setUserDetails(extraData);
                setLoginIDFV(extraData.login_id);
                setLoginFV(extraData.login);
                setNameFV(extraData.name);
                setStaffCodeFV(extraData.staff_code);
                setPasswordFV(extraData.password);
                setContactNoFV(extraData.contact_no);
                setEmailFV(extraData.email);
                setRemarkFV(extraData.remark);
                setIcNoFV(extraData.ic_no || empty);
                setAddressFV(extraData.address || empty);
                // setPhoneNumberFV(extraData.phone_number || empty); // merged into contact_no
                // setWorkStartTimeFV(normalizeTime(extraData.work_start_time)); // moved to Working Shift (shift_id)
                // setWorkEndTimeFV(normalizeTime(extraData.work_end_time));
                setShiftIdFV(extraData.shift_id ? String(extraData.shift_id) : empty);
                setRestDaysFV(parseRestDays(extraData.rest_days));
                setRestRepeatWeeksFV(extraData.rest_repeat_weeks ? String(extraData.rest_repeat_weeks) : empty);
                setRestStartDateFV(extraData.rest_start_date || empty);
                setBankNameFV(extraData.bank_name || empty);
                setBankAccountNoFV(extraData.bank_account_no || empty);
                setBankAccountNameFV(extraData.bank_account_name || empty);
            }
        }).catch(de);
    }

    const loadCustomerList = (config = axiosConfig) => {
        var parameters = '';
		if (gState.company) {
			const param = axiosURIencode({
				company: gState.company,
			});
			parameters = `?${param}`;
		}
        if(selectedUserDetails.company){
            const param = axiosURIencode({
                company: JSON.stringify([selectedUserDetails.company]),
            });
            parameters = `?${param}`;
        }
        API_Service.get(`${req_cust_list}${parameters}`, config).then(({data}) => {
            const {result, extraData} = data;
            if (parseInt(result) === 1) {
                var _arr = [];
                for (let i = 0; i < extraData.length; i++) {
                    const {cust_code, cust_company_name, customer_status, cust_category, cust_area} = extraData[i];
                    if (customer_status === '1') {
                        _arr.push({
                            name: cust_company_name,
                            secondary: cust_code,
                            value: cust_code,
                            cust_area : cust_area,
                            status: parseInt(customer_status)
                        });
                    }
                }

                if (_arr.length > 0) {
                    var filter = _arr.filter((obj) => {
                        return !outletList.some(obj2 => {
                            return obj.value === obj2.cust_code;
                        });
                    });
                    setFullCustomerList(fullCustomerList => (filter));
                } else {
                    // onSnack(language.no_data, 'warning');
                }
            }
        });
    }

    const resignUser = (data) => {
        setActionDialog(true);
        const _arr = [];
        for (let i = 0; i < data.length; i++) {
            var {dataIndex} = data[i];
            _arr.push(outletList[dataIndex]['cust_id']);
        }
        setSelectedOTR(_arr);
        setSearchArr(spList);
        setAction('resign');
    }

    const copyOutlet = (data) => {
        setActionDialog(true);
        const _arr = [];
        for (let i = 0; i < data.length; i++) {
            var {dataIndex} = data[i];
            _arr.push(outletList[dataIndex]['cust_id']);
        }
        setSelectedOTR(_arr);
        setSearchArr(spList);
        setAction('copy');
    }

    const actionDialogClose = () => {
        setActionDialog(false);
        setActionTo(null);
        setSearchArr(spList);
        setSelectedOTR([]);
        setAction(null);
    }

    const confirmDialog = (user_id, actions, config = axiosPut) => {
        var params = {
            login_id: selectedUserDetails.login_id,
            change_to: user_id,
            cust_id: selectedOTR
        };
        params = axiosURIencode(params);
        if(user_id){
            setLoading(true);
            switch(actions){
                case 'resign':
                    API_Service.put(`${req_resign_user}`, params, config).then(({data}) => {
                        var {result, message, extraData} = data;
                        if (result) {
                            snack("Success", 'success');
                            loadUserDetails(selectedUserDetails.login_id);
                            setActionDialog(false);
                            setActionTo(null);
                            setLoading(false);
                        } else {
                            snack("Failed", 'error');
                            setLoading(false);
                        }
                    });
                    break;
                case 'copy':
                    API_Service.put(`${req_copy_user}`, params, config).then(({data}) => {
                        var {result, message, extraData} = data;
                        if (result) {
                            snack("Success", 'success');
                            loadUserDetails(selectedUserDetails.login_id);
                            setActionDialog(false);
                            setActionTo(null);
                            setLoading(false);
                        } else {
                            snack("Failed", 'error');
                            setLoading(false);
                        }
                    });
                    break;
            }
        }
    }

    const handleChange = (event) => {
        if (event.target) {
            setActionTo(actionTo => (event.target.value));
        }
        event.persist();
    };

    const submitForm = (config = axiosPut) => {
        if (restRepeatWeeksValue !== empty && !restStartDateValue) {
            snack(language.rest_start_date_required, 'error');
            return;
        }
        if (branchesList.length > 0 && !selectedBranch) {
            snack(language.branch_required, 'error');
            return;
        }
        var rolePayload = resolveRolePayload(selectedRole, roleList);
        var params = {
            login_id: loginIDValue,
            login: loginValue,
            name: nameValue,
            staff_code: staffCodeValue,
            password: passwordValue,
            contact_no: contactNoValue,
            email: emailValue,
            remark: remarkValue,
            company: selectedBranch,
            regions_id: selectedRegion,
            role_id: rolePayload.role_id,
            position: rolePayload.position,
            lead_id: selectedLeader
        };
        if (gState.company) {
            params.company = selectedBranch;
        }
        params = axiosURIencode(params);

        var profileParams = axiosURIencode({
            login_id: loginIDValue,
            ic_no: icNoValue || '',
            address: addressValue || '',
            // phone_number: phoneNumberValue || '', // merged into contact_no, saved by req_update_user
            // work_start_time: workStartTimeValue || '', // moved to Working Shift (shift_id)
            // work_end_time: workEndTimeValue || '',
            shift_id: shiftIdValue === empty ? '' : shiftIdValue,
            rest_days: (restDaysValue || []).join(','),
            rest_repeat_weeks: restRepeatWeeksValue === empty ? '' : restRepeatWeeksValue,
            rest_start_date: restStartDateValue === empty ? '' : restStartDateValue,
            bank_name: bankNameValue || '',
            bank_account_no: bankAccountNoValue || '',
            bank_account_name: bankAccountNameValue || ''
        });

        var updatePromise = API_Service.put(req_update_user, params, config);
        var profilePromise = API_Service.put(req_manage_users_profile, profileParams, config);

        Promise.all([updatePromise, profilePromise]).then((results) => {
            var updRes = results[0].data || {};
            var profRes = results[1].data || {};
            var updResult = JString(updRes.result).toNumber();
            var profResult = JString(profRes.result).toNumber();

            if (updResult === 1 && profResult === 1) {
                snack("Success", 'success');
                seteditorclose();
                loadUserDetails(selectedUserDetails.login_id);
                setEdited(false);

                if (updRes.extraData && updRes.extraData.branch_changed === true) {
                    snack("Branch Changed", 'warning');
                }
            } else {
                snack("Failed", 'error');
            }
        }).catch(() => snack("Failed", 'error'));
    }

    const seteditorclose = () => {
        setEditorDialog(false);
        setLoginIDFV(empty);
        setLoginFV(empty);
        setNameFV(empty);
        setStaffCodeFV(empty);
        setPasswordFV(empty);
        setContactNoFV(empty);
        setEmailFV(empty);
        setRemarkFV(empty);
        setSelectedRegion(empty);
        setSelectedRole(empty);
        setSelectedBranch(empty);
        setSelectedLeader([]);
        setIcNoFV(empty);
        setAddressFV(empty);
        // setPhoneNumberFV(empty); // merged into contact_no
        // setWorkStartTimeFV(empty); // moved to Working Shift (shift_id)
        // setWorkEndTimeFV(empty);
        setShiftIdFV(empty);
        setRestDaysFV([]);
        setRestRepeatWeeksFV(empty);
        setRestStartDateFV(empty);
        setBankNameFV(empty);
        setBankAccountNoFV(empty);
        setBankAccountNameFV(empty);
        setEdited(false);
    }

    const seteditoropen = () => {
        setEditorDialog(true);
        setLoginIDFV(userDetails.login_id);
        setLoginFV(userDetails.login);
        setNameFV(userDetails.name);
        setStaffCodeFV(userDetails.staff_code);
        setPasswordFV(userDetails.password);
        setContactNoFV(userDetails.contact_no);
        setEmailFV(userDetails.email);
        setRemarkFV(userDetails.remark);
        setSelectedRegion(userDetails.region_id);
        if(!userDetails.lead_id || userDetails.lead_id == 0){
            setSelectedLeader([]);
        }else{
            setSelectedLeader(userDetails.lead_id);
        }
        setSelectedRole(isPromoter(userDetails.position) ? ADMIN_POSITION_PROMOTER : userDetails.role_id);
        setSelectedBranch(userDetails.company);
        setIcNoFV(userDetails.ic_no || empty);
        setAddressFV(userDetails.address || empty);
        // setPhoneNumberFV(userDetails.phone_number || empty); // merged into contact_no
        // setWorkStartTimeFV(normalizeTime(userDetails.work_start_time)); // moved to Working Shift (shift_id)
        // setWorkEndTimeFV(normalizeTime(userDetails.work_end_time));
        setShiftIdFV(userDetails.shift_id ? String(userDetails.shift_id) : empty);
        setRestDaysFV(parseRestDays(userDetails.rest_days));
        setRestRepeatWeeksFV(userDetails.rest_repeat_weeks ? String(userDetails.rest_repeat_weeks) : empty);
        setRestStartDateFV(userDetails.rest_start_date || empty);
        setBankNameFV(userDetails.bank_name || empty);
        setBankAccountNoFV(userDetails.bank_account_no || empty);
        setBankAccountNameFV(userDetails.bank_account_name || empty);
    }

    const toggleRestDay = (dayValue) => {
        setRestDaysFV((prev) => {
            var existing = prev || [];
            var next = existing.includes(dayValue)
                ? existing.filter((d) => d !== dayValue)
                : [...existing, dayValue].sort((a, b) => a - b);
            return next;
        });
        setEdited(true);
    };

    function escapeRegex(string) {
		return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}

    const onChangeSearchText = props => event => {
        var value = event.target.value;
        // value = String(value).split('?').join('').split('[').join('').split(']').join('').split("(").join('').split(')').join('');
        // var text = JString(value);
        var text = JString(escapeRegex(String(value)));
        var final = [];
        var search = (text.str).split(' ');
        if (text.isValid()) {
            for (let idx = 0; idx < spList.length; idx++) {
                var count = 0;
                const row = spList[idx];
                var searchString = row.value + row.name;
                for (let i = 0; i < search.length; i++) {
                    var isFound = JString(searchString).searchDeep(search[i]);
                    if (isFound) {
                        count++;
                    }
                }
                if (count === search.length) {
                    final.push(row);
                }
            }
            setSearchArr(final);
        } else {
            setSearchArr(spList);
        }
    }

    const handleChange2 = (event) => {
        if (event.target) {
            setSelectedRegion(selectedRegion => (event.target.value));
            setEdited(true);
        }
        event.persist();
    };

    const customerViewClose = (newValue) => {
        setNewOutletOpen(false);
        if (newValue) {
            if (newValue['name'] != 'reset') {
                var formdata = new FormData();
                formdata.append('login_id', userDetails.login_id);
                formdata.append('customer', JSON.stringify(newValue));
                if (userDetails?.company) {
                    formdata.append('company', userDetails?.company);    
                }
                formdata.append('status', 1);

                API_Service.post(req_update_user_outlet, formdata, axiosConfig).then(({data}) => {
                    var {result, extraData} = data;
                    if (result) {
                        snack("Update Success", 'success');
                        loadUserDetails(selectedUserDetails.login_id);
                    } else {
                        snack("Update Failed", 'error');
                    }
                });
            }
        }
    }

    const onRowDelete = (row) => {
        // de("betty-onRowDelete", row);
        const _arr = [];
        for (let i = 0; i < row.length; i++) {
            var {dataIndex} = row[i];
            _arr.push({
                name: outletList[dataIndex]['cust_company_name'],
                value: outletList[dataIndex]['cust_code']
            });
        }
        var formdata = new FormData();
        formdata.append('login_id', userDetails.login_id);
        formdata.append('customer', JSON.stringify(_arr));
        formdata.append('status', 0);
        API_Service.post(req_update_user_outlet, formdata, axiosConfig).then(({data}) => {
            var {result, extraData} = data;
            if (result) {
                snack("Update Success", 'success');
                loadUserDetails(selectedUserDetails.login_id);
            } else {
                snack("Update Failed", 'error');
            }
        });
    }

    const branchOnChange = (e) => {
        if (window.confirm("Switchting branch will clear all relation data. Are you sure you want to procees?")) {
            var _data = [];
            for (let idx = 0; idx < fullSPList.length; idx++) {
                const {name, login_id, company} = fullSPList[idx];
                if (login_id != selectedUserDetails.login_id && company === e.target.value) {
                    _data.push({name: name, value: login_id});
                }
            }
            setSpList(spList => (_data));
            setSelectedLeader([]);
            setSelectedBranch(e.target.value);
            setEdited(true);
        }
    }


    const loadConfig = (_client) => {
        API_Service.get(req_module_setting, axiosDefaultConfig(_client)).then(({data}) => {
            const {result, extraData} = data;
            if (result === 1) {
                const _config = getSetting(extraData, 'modules', {});
                setCountryIso2(getCountryIso2(extraData));
                // working_shift gate removed — show Working Shift for all clients (was: _config['working_shift'])
                setWorkingShiftEnabled(true);
                loadShifts(axiosDefaultConfig(_client));
                if (_config['branch'] === true) {

                    if (!itemDataCell.some(col => col.name === "company" && col.label === "Branch")) {

                    labels['company'] = "Branch";

                    itemDataCell.splice(2, 0, {
                        name: "company",
                        label: "Branch",
                        options: {
                            display: true,
                            customBodyRender: (value) => {
                                if (value) {
                                    const branch = JSON.parse(value);
                                    return branch.map((b)=><Chip size="small" label={b.toUpperCase()}/>);
                                }
                                return '';
                            }
                        }
                    });
                    
                    }
                    
                }
            }
        });
    };

    const loadShifts = (config) => {
        API_Service.get(req_working_shift_list, config).then(({data}) => {
            if (data) {
                var {result, extraData} = data;
                result = JString(result).toNumber();
                if (result === 1) {
                    var active = (extraData || []).filter((s) => parseInt(s.status, 10) === 1);
                    setShiftList(active);
                } else {
                    setShiftList([]);
                }
            }
        }).catch(() => snack(language.operation_fail || 'Error', 'error'));
    };

    const loadCustAreaList = (axiosRequestConfig) => {
        API_Service.get(req_cust_area, axiosRequestConfig).then(({data}) => {
            if (data) {
                var {result, extraData } = data;
                result = JString(result).toNumber();
                if (result === 1) {
                    var _act_data = [];
                    for (let i = 0; i < extraData.length; i++) {
                        const element = extraData[i];
                        if(JString(element['area_status']).toNumber() === 1){
                            _act_data.push(element);
                        }
                    }
                    // setCustomerAreaList(() => (extraData));
                    setActiveCustAreaList(()=>(_act_data));
                }
            }
        }).catch(err => de(err.message, 'customer area list'));
    } 


    return (
        <div className={classes.root}>
            {/* disableRestoreFocus: MUIDataTable's <table tabIndex=0> is the focused element when a row is clicked;
                restoring focus on close scrolls the table into view and jumps the list page */}
            <Dialog fullScreen open={open} onClose={() => onClose()} disableRestoreFocus>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={() => onClose()} aria-label="close">
                            <CloseIcon/>
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            { (currentPage == 0 && userDetails.role_id > 0) && (isPromoter(userDetails.position) ? language.promoter : userDetails.role_name) }
                            { (currentPage == 0 && userDetails.role_id == 0) && (language.user_details) }
                            { currentPage == 1 && (language.user_outlet_details) }
                            { currentPage === 2 && (language.attachments) }
                        </Typography>
                        {
                            currentPage == 0 && (
                                <Button
                                    onClick={seteditoropen}
                                    size="small">
                                    <EditIcon style={{color: 'black'}}/>
                                </Button>
                            )
                        }
                    </Toolbar>
                </AppBar>
                <DialogContent className={classes.dlgContent}>
                    {
                        currentPage == 0 && (
                            renderInfoView({
                                classes,
                                language,
                                userDetails
                            })
                        )
                    }
                    {
                        currentPage == 1 && (
                            <Grid container spacing={3} className={classes.grid}>
                                <Grid item xs={12}>
                                    <MUIDataTable
                                        title={language.user_outlet_list}
                                        data={outletList}
                                        columns={itemDataCell}
                                        options={{
                                            print: false,
                                            filter: false,
                                            rowsPerPage: 99,
                                            rowsPerPageOptions: [125, 140, 165, 200],
                                            responsive: 'scrollMaxHeight',
                                            download: true,
                                            downloadOptions: {
                                                filterOptions: {
                                                    useDisplayedColumnsOnly: true,
                                                    useDisplayedRowsOnly: true
                                                },
                                                filename: `Outlet_Detail_Report_By_${selectedUserDetails?.name || 'Unknown'}.csv`
                                            },
                                            onDownload: (buildHead, buildBody, columns, data) => {
                                                // 创建自定义表头 - 添加一个额外的列作为序号列
                                                const customHeadRow1 = ['""'].concat(columns.map((col, index) => {
                                                    if (index === 0) {
                                                        return '"OUTLET DETAIL REPORT"'; // 第1行第2列显示标题
                                                    } else if (index === 1) {
                                                        return '"USER LOGIN NAME : ' + (selectedUserDetails?.name || '') + '"'; // 第1行第3列显示用户名
                                                    } else {
                                                        return '""';
                                                    }
                                                })).join(',');
                                                
                                                // 创建标题行（第2行）- 添加"No"作为第一列
                                                const customHeadRow2 = ['"No"'].concat(columns.map(col => {
                                                    return '"' + col.label + '"'; // 保留原有的所有列标题
                                                })).join(',');
                                                
                                                // 创建数据行，添加序号作为第一列
                                                const customBody = data.map((row, rowIndex) => {
                                                    // 添加序号作为第一列
                                                    const dataRow = ['"' + (rowIndex + 1) + '"'].concat(row.data.map((cell, cellIndex) => {
                                                        // 找到 customer_status 列的索引
                                                        const statusColumnIndex = columns.findIndex(col => col.name === 'customer_status');
                                                        
                                                        // 如果是状态列，进行转换
                                                        if (cellIndex === statusColumnIndex) {
                                                            const statusValue = cell === "1" ? "Active" : "Inactive";
                                                            return '"' + statusValue + '"';
                                                        }
                                                        
                                                        return '"' + (cell || '').toString().replace(/"/g, '""') + '"';
                                                    })).join(',');
                                                    return dataRow;
                                                }).join('\n');
                                                
                                                // 组合自定义表头和数据
                                                const csvContent = customHeadRow1 + '\n' + customHeadRow2 + '\n' + customBody;
                                                
                                                // 返回自定义CSV内容
                                                return csvContent;
                                            },
                                            viewColumns: false,
                                            selectableRows: outletList.length > 0 ? 'multiple' : 'none',
                                            customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
                                                const data = selectedRows?.data;
                                                return (
                                                    <div style={{marginRight: 25}}>
                                                        <ToolbarCustomSelect
                                                            title={'Copy outlet to'}
                                                            onClick={() => {
                                                                copyOutlet(data)
                                                            }}
                                                        >
                                                            <FileCopyIcon/>
                                                        </ToolbarCustomSelect>
                                                        <ToolbarCustomSelect
                                                            title={'Resign'}
                                                            onClick={() => {
                                                                resignUser(data)
                                                            }}
                                                        >
                                                            <SendIcon/>
                                                        </ToolbarCustomSelect>
                                                        <ToolbarCustomSelect
                                                            title={'Delete'}
                                                            onClick={() => {
                                                                onRowDelete(data)
                                                            }}
                                                        >
                                                            <DeleteIcon/>
                                                        </ToolbarCustomSelect>
                                                    </div>
                                                )
                                            },
                                            onRowsDelete: ({data: row}) => onRowDelete(row),
                                            setTableProps: () => ({size: 'small'}),
                                            customToolbar: () =>
                                                <TemplateTableCustomToolbar
                                                    addCustomer={() => {
                                                        setNewOutletOpen(true)
                                                    }}
                                                />
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        )
                    }
                    {
                        currentPage === 2 && (
                            <AttachmentTab
                                classes={classes}
                                loginId={userDetails.login_id}
                                userName={userDetails.name}
                                userLogin={userDetails.login}
                                language={language}
                                axiosConfig={axiosConfig}
                                axiosPut={axiosPut}
                                snack={snack}/>
                        )
                    }
                </DialogContent>
                <DialogActions>
                    <BottomNavigation
                        value={currentPage}
                        onChange={(event, newValue) => {
                            setCurrentPage(newValue);
                        }}
                        showLabels
                        className={classes.bottomNav}>
                        <BottomNavigationAction label="Info" icon={<InfoIcon/>}/>
                        <BottomNavigationAction label="Outlet" icon={<PersonOutlineIcon/>}/>
                        <BottomNavigationAction label={language.attachment} icon={<AttachmentIcon/>}/>
                    </BottomNavigation>
                </DialogActions>
            </Dialog>

            <Dialog
                fullScreen={fullScreen}
                maxWidth={'lg'}
                open={actionDialog}
                onClose={() => actionDialogClose()}
                aria-labelledby="responsive-dialog-title">
                <DialogTitle
                    id="responsive-dialog-title">
                    {
                        action == 'resign' && (
                            <>
                            {language.resigning}
                            <p className={classes.text}>{language.resign_user_confirm1}<br/>{language.resign_user_confirm2}</p>
                            </>
                        )
                    }
                    {
                        action == 'copy' && (
                            <>
                            {language.copy_user}
                            <p className={classes.text}>{language.copy_user_confirm1}<br/>{language.copy_user_confirm2}</p>
                            </>
                        )
                    }
                    <div className={classes.viewInRow}>
                        <div className={searchClass.search}>
                            <div className={searchClass.searchIcon}>
                                <SearchIcon/>
                            </div>
                            <InputBase
                                placeholder={language.search}
                                classes={{
                                    root: searchClass.inputRoot,
                                    input: searchClass.inputInput,
                                }}
                                inputProps={{'aria-label': 'search'}}
                                onChange={onChangeSearchText('search')}
                            />
                        </div>
                    </div>
                </DialogTitle>
                <DialogContent style={{paddingTop: 0}}>
                    <div style={{flexDirection: 'column'}}>
                        <RadioGroup
                            ref={radioGroupRef}
                            value={actionTo}
                            onChange={handleChange}
                            style={{width: 600}}>
                            {searchArr.map((option, idx) => {
                                if (idx !== searchArr.length) {
                                    return (
                                        <FormControlLabel
                                            value={option.value}
                                            key={String(idx)}
                                            control={<Radio/>}
                                            label={option.name}/>
                                    )
                                } else {
                                    return (
                                        null
                                    )
                                }
                            })}
                        </RadioGroup>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={() => actionDialogClose()} color="inherit" disabled={loading}>
                        {language.cancel}
                    </Button>
                    <Button onClick={()=>confirmDialog(actionTo, action)} color="inherit" autoFocus disabled={actionTo == null || loading}>
                        {
                            loading ? <CircularProgress size={20}/> : language.ok
                        }
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                fullScreen={fullScreen}
                maxWidth={'sm'}
                open={editorDialog}
                onClose={seteditorclose}
                aria-labelledby="responsive-dialog-title">
                <DialogTitle id="responsive-dialog-title" style={{paddingBottom: 5}}>
                    {language.edit}
                </DialogTitle>
                <DialogContent>
                    <div className={classes.viewInRowSpace}>
                        {/* <TextField
                            className={classes.input}
                            id="input-login-id"
                            label={"Login ID"}
                            value={loginIDValue}
                            disabled={true}
                            onChange={(e) => setLoginIDFV(e.target.value)}
                        /> */}
                        <TextField
                            id="input-staff-code"
                            className={classes.input}
                            label={"Staff Code"}
                            value={staffCodeValue}
                            disabled={true}
                            onChange={(e) => setStaffCodeFV(e.target.value)}
                        />
                        <TextField
                            id="input-login"
                            className={classes.input}
                            label={'Login'}
                            value={loginValue}
                            disabled={true}
                            onChange={(e) => setLoginFV(e.target.value)}
                        />
                        <TextField
                            id="input-name"
                            className={classes.input}
                            label={'Name'}
                            value={nameValue}
                            onChange={(e) => {
                                setNameFV(e.target.value);
                                setEdited(true);
                            }}
                        />
                        <TextField
                            id="input-password"
                            className={classes.input}
                            label={language.password}
                            value={passwordValue}
                            type={showPassword ? "text" : "password"}
                            onChange={(e) => {
                                setPasswordFV(e.target.value);
                                setEdited(true);
                            }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Tooltip title={showPassword ? language.hide_password : language.show_password}>
                                            <IconButton
                                                aria-label={showPassword ? language.hide_password : language.show_password}
                                                onClick={() => setShowPassword((s) => !s)}
                                                onMouseDown={(e) => e.preventDefault()}
                                                edge="end"
                                                size="small"
                                                tabIndex={-1}
                                            >
                                                {showPassword
                                                    ? <VisibilityOff fontSize="small"/>
                                                    : <Visibility fontSize="small"/>}
                                            </IconButton>
                                        </Tooltip>
                                    </InputAdornment>
                                )
                            }}
                        />
                        <MuiPhoneNumber
                            className={classes.input}
                            name="phone"
                            label={language.phone_number}
                            InputLabelProps={{
                                style: {color: grey[500]},
                            }}
                            data-cy="user-phone"
                            key={countryIso2}
                            defaultCountry={countryIso2}
                            value={contactNoValue}
                            onChange={prop => {
                                setContactNoFV(prop);
                                setEdited(true);
                            }}
                            countryCodeEditable={false}
                            fullWidth
                            margin={'dense'}
                            regions={['asia']}
                        />
                        <TextField
                            id="input-email"
                            className={classes.input}
                            label={"Email"}
                            autoComplete="off"
                            value={emailValue}
                            onChange={(e) => {
                                setEmailFV(e.target.value);
                                setEdited(true);
                            }}
                        />
                        <FormControl className={classes.input}>
                            <InputLabel id="demo-simple-select-label">{language.region}</InputLabel>
                            <Select
                                value={selectedRegion}
                                onChange={(e) => {setSelectedRegion(e.target.value);setEdited(true);}}
                            >
                                {regionList.map((region) => (
                                    <MenuItem
                                        value={region.id}
                                        key={region.id}
                                    >
                                        {region.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl className={classes.input}>
                            <InputLabel id="demo-simple-select-label">Role</InputLabel>
                            <Select
                                value={selectedRole}
                                onChange={(e) => {
                                    // if(e.target.value == 1){
                                    //     setSelectedLeader([]);
                                    // }
                                    setSelectedRole(e.target.value);
                                    setEdited(true);
                                }}
                            >
                                {roleList.map((role) => (
                                    <MenuItem
                                        value={role.role_id}
                                        key={role.role_id}
                                    >
                                        {role.role_id === ADMIN_POSITION_PROMOTER ? language.promoter : role.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        {
                            (selectedRole == '2' || selectedRole === ADMIN_POSITION_PROMOTER) && (
                                <FormControl className={classes.input}>
                                    <InputLabel id="demo-simple-select-label">Manager</InputLabel>
                                    <Select
                                        value={selectedLeader}
                                        onChange={(e) => {setSelectedLeader(e.target.value);setEdited(true);}}
                                        multiple
                                        renderValue={(selected) => spList
                                            .filter((sp) => selected.map(String).includes(String(sp.value)))
                                            .map((sp) => sp.name)
                                            .join(', ')}
                                    >
                                        {spList.map((saleperson) => (
                                            <MenuItem
                                                value={saleperson.value}
                                                key={saleperson.value}
                                            >
                                                {saleperson.name}
                                                {isPromoter(saleperson.position) && (
                                                    <Chip size="small" className={classes.promoterChip} label={language.promoter}/>
                                                )}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            )
                        }
                        {
                            branchesList.length > 0 && (
                                <FormControl className={classes.input}>
                                    <InputLabel id="demo-simple-select-label">Branch</InputLabel>
                                    <Select
                                        disabled={gState.company}
                                        value={selectedBranch}
                                        onChange={(e) => {
                                            branchOnChange(e);
                                        }}
                                    >
                                        {branchesList.map((role) => (
                                            <MenuItem value={role.value} key={role.value}>{role.name.toUpperCase()}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            )
                        }
                        <TextField
                            id="input-remark"
                            className={classes.remark}
                            label={language.remark}
                            value={remarkValue}
                            onChange={(e) => {
                                setRemarkFV(e.target.value)
                                setEdited(true)
                            }}
                        />
                    </div>
                    <div style={{marginTop: 16}}>
                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography>{language.personal}</Typography>
                            </AccordionSummary>
                            <AccordionDetails style={{flexDirection: 'column'}}>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    label={language.ic_no}
                                    value={icNoValue}
                                    onChange={(e) => { setIcNoFV(e.target.value); setEdited(true); }}
                                />
                                {/* Phone Number merged into contact_no — edited by the phone field above */}
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    label={language.address}
                                    value={addressValue}
                                    multiline
                                    rows={2}
                                    onChange={(e) => { setAddressFV(e.target.value); setEdited(true); }}
                                />
                            </AccordionDetails>
                        </Accordion>
                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography>{language.working_time}</Typography>
                            </AccordionSummary>
                            <AccordionDetails style={{flexDirection: 'column'}}>
                                {workingShiftEnabled && (
                                    <FormControl variant="standard" margin="dense" fullWidth>
                                        <InputLabel>{language.working_shift}</InputLabel>
                                        <Select
                                            value={shiftIdValue}
                                            onChange={(e) => { setShiftIdFV(e.target.value); setEdited(true); }}
                                        >
                                            <MenuItem value={empty}><em>-</em></MenuItem>
                                            {shiftList.map((s) => (
                                                <MenuItem key={'us-sh-' + s.id} value={String(s.id)}>{formatShiftLabel(s)}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                )}
                                <Typography variant="caption" style={{display: 'block', marginTop: 8}}>
                                    {language.select_rest_day}
                                </Typography>
                                <div>
                                    {REST_DAYS.map((d) => {
                                        var selected = (restDaysValue || []).includes(d.value);
                                        return (
                                            <Chip
                                                key={'us-rd-' + d.value}
                                                size="small"
                                                label={language[d.labelKey]}
                                                clickable
                                                color={selected ? 'primary' : 'default'}
                                                style={{marginRight: 4, marginBottom: 4}}
                                                onClick={() => toggleRestDay(d.value)}
                                            />
                                        );
                                    })}
                                </div>
                                <div style={{display: 'flex', alignItems: 'center', gap: 8, marginTop: 8}}>
                                    <Typography variant="body2">{language.repeats_every}</Typography>
                                    <FormControl variant="standard">
                                        <Select
                                            value={restRepeatWeeksValue}
                                            onChange={(e) => { setRestRepeatWeeksFV(e.target.value); setEdited(true); }}
                                            displayEmpty
                                        >
                                            <MenuItem value={empty}><em>-</em></MenuItem>
                                            {REST_REPEAT_OPTIONS.map((n) => (
                                                <MenuItem key={'us-rr-' + n} value={String(n)}>{n}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <Typography variant="body2">{language.week}</Typography>
                                </div>
                                {restRepeatWeeksValue !== empty ? (
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <DatePicker
                                            className={classes.restStartSpacing}
                                            views={['year', 'date']}
                                            format="dd-MM-yyyy"
                                            label={language.rest_start_date}
                                            inputVariant="standard"
                                            margin="dense"
                                            fullWidth
                                            value={restStartDateValue ? moment(restStartDateValue, 'YYYY-MM-DD').toDate() : null}
                                            onChange={(date) => { setRestStartDateFV(date ? moment(date).format('YYYY-MM-DD') : empty); setEdited(true); }}
                                        />
                                    </MuiPickersUtilsProvider>
                                ) : null}
                            </AccordionDetails>
                        </Accordion>
                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography>{language.bank_details}</Typography>
                            </AccordionSummary>
                            <AccordionDetails style={{flexDirection: 'column'}}>
                                <FormControl variant="standard" margin="dense" fullWidth>
                                    <InputLabel>{language.bank_name}</InputLabel>
                                    <Select
                                        value={bankNameValue}
                                        onChange={(e) => { setBankNameFV(e.target.value); setEdited(true); }}
                                    >
                                        <MenuItem value={empty}><em>-</em></MenuItem>
                                        {MY_BANKS.map((b) => (
                                            <MenuItem key={'us-bk-' + b} value={b}>{b}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    label={language.bank_account_name}
                                    value={bankAccountNameValue}
                                    onChange={(e) => { setBankAccountNameFV(e.target.value); setEdited(true); }}
                                />
                                <TextField
                                    fullWidth
                                    margin="dense"
                                    label={language.bank_account_number}
                                    value={bankAccountNoValue}
                                    onChange={(e) => { setBankAccountNoFV(e.target.value); setEdited(true); }}
                                />
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        disabled={edited ? false : true}
                        variant="outlined"
                        onClick={()=>submitForm()}
                        color={'primary'}>
                        {language.update}
                    </Button>
                </DialogActions>
            </Dialog>

            {
                newOutletOpen && (
                    <VirtualListCA
                        setClose={(d) => customerViewClose(d)}
                        open={newOutletOpen}
                        title={'New User Outlet'}
                        data={fullCustomerList}
                        language={language}
                        filteration={0}
                        activeCustAreaList = {activeCustAreaList}
                    />
                )
            }
        </div>
    )
}

function TemplateTableCustomToolbar({addCustomer}) {
    return (
        <React.Fragment>
            <Tooltip title={'Add Outlet'}>
                <IconButton
                    edge={'end'}
                    color={'primary'}
                    onClick={() => addCustomer()} aria-label="addnew">
                    <AddIcon/>
                </IconButton>
            </Tooltip>
        </React.Fragment>
    )
}

export function ToolbarCustomSelect({onClick, title, children}) {
    return (
        <React.Fragment>
            <Tooltip title={title}>
                <IconButton onClick={() => onClick()}>
                    {children}
                </IconButton>
            </Tooltip>
        </React.Fragment>
    )
}

function getInitials(name) {
    if (!name) return '?';
    var parts = String(name).trim().split(/\s+/);
    if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function isActiveUser(userDetails) {
    if (userDetails == null) return true;
    var s = userDetails.active_status;
    if (s === undefined || s === null) return true;
    return String(s) !== '0' && String(s).toLowerCase() !== 'inactive';
}

function InfoField({classes, label, value, emptyText}) {
    var isEmpty = value === null || value === undefined || value === '' || value === '-';
    return (
        <div className={classes.infoFieldWrapper}>
            <div className={classes.infoLabel}>{label}</div>
            {
                isEmpty
                    ? <div className={classes.emptyValue}>{emptyText || '—'}</div>
                    : <div className={classes.infoValue}>{value}</div>
            }
        </div>
    );
}

function InfoSection({classes, icon, title, children}) {
    return (
        <div className={classes.sectionCard}>
            <div className={classes.sectionHeader}>
                <div className={classes.sectionAccent}/>
                <div className={classes.sectionIcon}>{icon}</div>
                <div className={classes.sectionTitle}>{title}</div>
            </div>
            {children}
        </div>
    );
}

function InfoSkeleton({classes}) {
    return (
        <div className={classes.infoContainer}>
            <div className={classes.identityHeader}>
                <Skeleton variant="circle" width={64} height={64} animation="wave"/>
                <div style={{flex: 1, minWidth: 220}}>
                    <Skeleton variant="text" width="40%" height={28} animation="wave"/>
                    <Skeleton variant="text" width="60%" height={16} animation="wave"/>
                    <Skeleton variant="text" width="30%" height={20} animation="wave"/>
                </div>
            </div>
            <Grid container spacing={3}>
                {[0, 1, 2, 3].map((i) => (
                    <Grid item xs={12} md={6} key={'sk-' + i}>
                        <div className={classes.sectionCard}>
                            <Skeleton variant="text" width="35%" height={24} animation="wave"/>
                            <Skeleton variant="rect" height={48} animation="wave" style={{marginTop: 12, borderRadius: 10}}/>
                            <Skeleton variant="rect" height={48} animation="wave" style={{marginTop: 8, borderRadius: 10}}/>
                            <Skeleton variant="rect" height={48} animation="wave" style={{marginTop: 8, borderRadius: 10}}/>
                        </div>
                    </Grid>
                ))}
            </Grid>
        </div>
    );
}

function renderInfoView({classes, language, userDetails}) {
    if (!userDetails || !userDetails.login_id) {
        return <InfoSkeleton classes={classes}/>;
    }

    var name = userDetails.name || '';
    var initials = getInitials(name);
    var active = isActiveUser(userDetails);
    var branchLabel = userDetails.company ? String(userDetails.company).toUpperCase() : '';

    var userIsPromoter = isPromoter(userDetails.position);
    var roleBadgeClass = classes.roleBadge;
    if (userIsPromoter) {
        roleBadgeClass = classes.roleBadgePromoter;
    } else if (userDetails.role_name === 'Manager') {
        roleBadgeClass = classes.roleBadgeManager;
    } else if (userDetails.role_name === 'Agent') {
        roleBadgeClass = classes.roleBadgeAgent;
    }

    var metaParts = [];
    if (userDetails.login) metaParts.push({label: language.login, value: userDetails.login});
    if (userDetails.staff_code) metaParts.push({label: language.staff_code, value: userDetails.staff_code});
    if (branchLabel) metaParts.push({label: language.branch, value: branchLabel});

    var restDays = parseRestDays(userDetails.rest_days);
    var shiftLabel = userDetails.shift_name
        ? formatShiftLabel({shift_name: userDetails.shift_name, start_time: userDetails.shift_start_time, end_time: userDetails.shift_end_time})
        : '';

    return (
        <div className={classes.infoContainer}>
            <div className={classes.identityHeader}>
                <div className={classes.avatarCircle}>{initials}</div>
                <div className={classes.identityMain}>
                    <div className={classes.identityName}>{name || '—'}</div>
                    {
                        metaParts.length > 0 && (
                            <div className={classes.identityMeta}>
                                {metaParts.map((p, i) => (
                                    <React.Fragment key={'meta-' + i}>
                                        {i > 0 && <span className={classes.identityMetaSep}>·</span>}
                                        <span className={classes.identityMetaLabel}>{p.label}:</span>
                                        <span className={classes.identityMetaValue}>{p.value}</span>
                                    </React.Fragment>
                                ))}
                            </div>
                        )
                    }
                    <div className={classes.identityBadges}>
                        {
                            userDetails.role_id > 0 && userDetails.role_name && (
                                <Chip
                                    size="small"
                                    className={roleBadgeClass}
                                    label={userIsPromoter ? language.promoter : userDetails.role_name}
                                />
                            )
                        }
                        <span className={classes.statusDotWrap}>
                            <span className={active ? classes.statusDotActive : classes.statusDotInactive}/>
                            {active ? language.active : language.inactive}
                        </span>
                    </div>
                </div>
                {/* Email and Phone Number moved to the Personal section */}
            </div>

            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <InfoSection classes={classes} icon={<PersonIcon/>} title={language.personal}>
                        <InfoField classes={classes} label={language.ic_no} value={userDetails.ic_no}/>
                        <InfoField classes={classes} label={language.phone_number} value={userDetails.contact_no}/>
                        <InfoField classes={classes} label={language.email} value={userDetails.email}/>
                        <InfoField classes={classes} label={language.address} value={userDetails.address}/>
                    </InfoSection>
                </Grid>

                <Grid item xs={12} md={6}>
                    <InfoSection classes={classes} icon={<PublicIcon/>} title={language.position}>
                        <InfoField
                            classes={classes}
                            label={language.region}
                            value={userDetails.region_id > 0 ? userDetails.region_name : null}
                            emptyText={language.regions_no_data}
                        />
                        <InfoField
                            classes={classes}
                            label={language.user_role}
                            value={userDetails.role_id > 0
                                ? (isPromoter(userDetails.position) ? language.promoter : userDetails.role_name)
                                : null}
                            emptyText={language.no_role_assigned}
                        />
                        <div className={classes.infoFieldWrapper}>
                            <div className={classes.infoLabel}>{language.user_group}</div>
                            {
                                (userDetails.group && userDetails.group.length > 0) ? (
                                    <div style={{marginTop: 4}}>
                                        {userDetails.group.map((g, i) => (
                                            <Chip
                                                key={'grp-' + i}
                                                size="small"
                                                className={classes.groupChip}
                                                label={`${g.role}: ${g.name}`}
                                            />
                                        ))}
                                    </div>
                                ) : (
                                    <div className={classes.emptyValue}>{language.no_group_found}</div>
                                )
                            }
                        </div>
                        {
                            userDetails.remark && (
                                <InfoField
                                    classes={classes}
                                    label={language.remark}
                                    value={userDetails.remark}
                                />
                            )
                        }
                    </InfoSection>
                </Grid>

                <Grid item xs={12} md={6}>
                    <InfoSection classes={classes} icon={<AccessTimeIcon/>} title={language.working_time}>
                        <InfoField
                            classes={classes}
                            label={language.working_shift}
                            value={shiftLabel || null}
                        />
                        <div className={classes.infoFieldWrapper}>
                            <div className={classes.infoLabel}>{language.rest_day}</div>
                            {
                                restDays.length > 0 ? (
                                    <>
                                        <div style={{marginTop: 4}}>
                                            {REST_DAYS.map((d) => {
                                                var selected = restDays.includes(d.value);
                                                return (
                                                    <Chip
                                                        key={'view-rd-' + d.value}
                                                        size="small"
                                                        label={language[d.labelKey]}
                                                        className={selected ? classes.restDayChipActive : classes.restDayChip}
                                                        variant={selected ? 'default' : 'outlined'}
                                                    />
                                                );
                                            })}
                                        </div>
                                        {
                                            userDetails.rest_repeat_weeks && (
                                                <div className={classes.repeatNote}>
                                                    {language.repeats_every} {userDetails.rest_repeat_weeks} {language.week}
                                                    {userDetails.rest_start_date ? ' · ' + language.rest_start_date + ': ' + moment(userDetails.rest_start_date, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''}
                                                </div>
                                            )
                                        }
                                    </>
                                ) : (
                                    <div className={classes.emptyValue}>—</div>
                                )
                            }
                        </div>
                    </InfoSection>
                </Grid>

                <Grid item xs={12} md={6}>
                    <InfoSection classes={classes} icon={<AccountBalanceIcon/>} title={language.bank_details}>
                        <InfoField classes={classes} label={language.bank_name} value={userDetails.bank_name}/>
                        <InfoField classes={classes} label={language.bank_account_name} value={userDetails.bank_account_name}/>
                        <InfoField classes={classes} label={language.bank_account_number} value={userDetails.bank_account_no}/>
                    </InfoSection>
                </Grid>
            </Grid>
        </div>
    );
}
